
angular.module('membership')
  .controller('RoleDetailsBaseCtrl', [
    '$scope', '$stateParams',
    function($scope, $stateParams) {
      $scope.tab = $stateParams.tab;
      $scope.roleId = $stateParams.id;
    }
  ]);